import React from 'react';
import { StyledComponent, StyledForm, StyledModal } from './style';
import { Form, Select, Button, message, DatePicker } from 'antd';
import themeSettings from './Utils/themeSettings.json';
import {
  getDeviceList,
  getHierarchyFromAPI,
  getList,
  getListById,
  submit
} from './Utils/FormCalls';
import moment from 'moment';
import history from '../../../commons/history';
import _ from 'lodash';
import HierarchyModal from './Utils/HierarchyModal';
import { UpSquareOutlined } from '@ant-design/icons';
import { API_ASSET, MAXIMOASSET, API_DEVICETYPE } from '../../../commons/api';
const { Option } = Select;
const { TimePicker } = DatePicker;

const ApiList = {
  getAssetList: `${API_ASSET.GETASSETBYMODULE}`,
  getDeviceTypeListByAsset: `${API_DEVICETYPE.getDeviceTypeListByAsset}`,
  getDeviceListByDeviceType: `${MAXIMOASSET.DeviceList}`,
  getFaultCodesList: `${MAXIMOASSET.FaultCodeList}`,
  Submit: `${MAXIMOASSET.UpdateAFCDetails}`
};

class SRHaltTime extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formObject: {},
      stationList: [],
      deviceTypeList: [],
      deviceList: [],
      treeVisible: false,
      selectedDevices: [],
      record:
        this.props.location && this.props.location.state ? this.props.location.state.record : {}
    };
  }
  hRef = React.createRef();

  componentDidMount = async () => {
    this.getData();
    let formObject = this.state.record;
    let data = this.hRef.current ? this.hRef.current.getFieldsValue() : null;
    await this.fieldOnChange(data.Station, 'Station');
    await this.fieldOnChange(data.deviceType, 'deviceType');
    await this.fieldOnChange(data.DeviceCode, 'DeviceCode');
    this.getHierarchyData();
    let deviceList = await getDeviceList();
    let stationList1 = await getList(
      ApiList.getAssetList,
      'Type',
      'Plain',
      'AssetType',
      'location'
    );
    let stationList = [
      ...(stationList1 && Array.isArray(stationList1) && stationList1.length > 0
        ? [{ AssetCode: 'All', Name: 'All' }]
        : []),
      ...stationList1
    ];
    this.setState({ stationList, formObject, deviceList });
  };

  getHierarchyData = async () => {
    let path = history.location.pathname.split('/rubus/Maximo/');
    let Module = path[1].split('/') && path[1].split('/')[0];
    let hierarchy = await getHierarchyFromAPI(Module);
    this.setState({ hierarchy });
  };

  getData = async () => {
    let formObject = {};
    formObject = this.state.record;
    _.cloneDeepWith(formObject, (value) => {
      return value && value !== null && value.Interval
        ? {
            ...value,
            ...(value.Interval = moment.utc(value.Interval, 'HH:mm:ss'))
          }
        : _.noop();
    });
    if (this.hRef.current) {
      this.hRef.current.setFieldsValue(formObject);
    }
    this.setState({
      formObject
    });
  };
  fieldOnChange = async (value, key) => {
    let { formObject, deviceTypeList, deviceList, FaultCodesList } = this.state;
    let path = history.location.pathname.split('/rubus/Maximo/');
    let Module = path[1].split('/') && path[1].split('/')[0];
    if (value !== undefined) {
      if (key === 'Station') {
        formObject = {
          ...formObject,
          [key]: value
        };
        let payload = {
          AssetCode: value
        };
        let deviceTypeList1 = await getListById(ApiList.getDeviceTypeListByAsset, payload);
        deviceTypeList = [
          ...(deviceTypeList1 && Array.isArray(deviceTypeList1) && deviceTypeList1.length > 0
            ? [{ AssetCode: 'All', Code: 'All', Description: 'All', AssetName: 'All' }]
            : []),
          ...deviceTypeList1
        ];
      } else if (key === 'deviceType') {
        //    let array1 = deviceTypeList.filter(function(item) {
        //         return value.includes(item.Code);
        //       });
        //       let AssetCode=[];
        //       array1.map((i)=>{
        //         AssetCode.push(i.AssetCode);
        //       });
        formObject = {
          ...formObject,
          [key]: value
        };
        let payload = {
          Module: Module,
          AssetDeviceType: value
        };
        let deviceList1 = await getListById(ApiList.getDeviceListByDeviceType, payload);
        deviceList = [
          ...(deviceList1 && Array.isArray(deviceList1) && deviceList1.length > 0
            ? [{ AssetCode: 'All', DeviceCode: 'All', DeviceName: 'All', Description: 'All' }]
            : []),
          ...deviceList1
        ];
      } else if (key === 'DeviceCode') {
        formObject = {
          ...formObject,
          [key]: value
        };
        let payload = {
          Module: Module,
          DeviceCode: value
        };
        let FaultCodesList1 = await getListById(ApiList.getFaultCodesList, payload);
        FaultCodesList = [
          ...(FaultCodesList1 && Array.isArray(FaultCodesList1) && FaultCodesList1.length > 0
            ? [{ DeviceCode: 'All', Code: 'All', Description: 'All', DeviceName: 'All' }]
            : []),
          ...FaultCodesList1
        ];
      } else if (key === 'Interval') {
        formObject = {
          ...formObject,
          [key]: value
        };
        this.setState({ formObject });
        if (this.hRef.current !== null) {
          this.hRef.current.setFieldsValue(formObject);
        }
      }
    }
    if (this.hRef.current !== null) {
      this.hRef.current.setFieldsValue(formObject);
    }
    this.setState({ formObject, deviceTypeList, deviceList, FaultCodesList });
  };
  onFormsubmit = () => {
    let { selectedDeviceObject } = this.state;
    let path = history.location.pathname.split('/rubus/Maximo/');
    let Module = path[1].split('/') && path[1].split('/')[0];
    this.hRef.current
      .validateFields()
      .then(async (values) => {
        let payload = {
          ...values,
          DeviceCode: selectedDeviceObject,
          Interval: moment(values.Interval).format('00:mm:ss'),
          Module: Module
        };
        let response = await submit(ApiList.Submit, payload);
        message.success(response.message);
      })
      .catch(() => {});
  };

  onModalsOk = (e) => {
    let { selectedDeviceObject } = this.state;
    e.preventDefault();
    this.fieldOnChange(selectedDeviceObject, 'DeviceCode');
    this.setState({
      treeVisible: false
    });
  };

  onModalCancel = () => {
    this.setState({
      treeVisible: false
    });
  };

  hierarchyDropdownChange = (sd, sdObject) => {
    let selectedDevice = [];
    let selectedDeviceObject = [];
    selectedDeviceObject =
      sdObject &&
      sdObject
        .filter((d) => d.children && d.children.length === 0)
        .map((da) => {
          selectedDevice.push(da.key);
          return da;
        });
    this.setState({ selectedDevice, selectedDeviceObject });
  };
  render() {
    let { formObject, selectedDevice, deviceList, FaultCodesList } = this.state;

    // const formItemLayout = { width: '100%', flex: '50%' };
    /* eslint-disable no-template-curly-in-string */
    const validateMessages = {
      required: '${label} is required!',
      types: {
        email: '${label} is not a valid email!',
        number: '${label} is not a valid number!'
      },
      number: {
        range: '${label} must be between ${min} and ${max}'
      }
    };
    return (
      <StyledComponent
        theme={themeSettings}
        style={{ padding: '50px 30px', minHeight: window.innerHeight - 117 }}
      >
        <StyledForm
          name="Equipment Master"
          theme={themeSettings}
          ref={this.hRef}
          onFinish={this.onFormsubmit}
          onFinishFailed={this.onFinishFailed}
          initialValues={formObject || {}}
          layout="horizontal"
          labelCol={{ flex: '200px' }}
          labelAlign="right"
          labelWrap
          // wrapperCol={{ flex: 1 }}
          validateMessages={validateMessages}
        >
          <div style={{ display: 'flex', justifyContent: 'right' }}>
            <Form.Item>
              <Button theme={themeSettings} type="primary" htmlType="submit">
                {'Submit'}
              </Button>
            </Form.Item>
          </div>

          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Form.Item
              name={'DeviceCode'}
              label={'Select Device'}
              rules={[{ required: false, message: 'Please Select Device!' }]}
              style={{
                width: '100%',
                flex: '100%'
              }}
            >
              <span
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start'
                }}
              >
                <Select
                  style={{
                    width: '75%',
                    opacity: 1,
                    pointerEvents: 'none'
                  }}
                  value={selectedDevice}
                  mode="multiple"
                  placeholder={'Select Device'}
                  size="default"
                >
                  {deviceList &&
                    Array.isArray(deviceList) &&
                    deviceList.map((device, index) => {
                      return (
                        <Option key={index} value={`${device.DeviceCode}`}>
                          {device.Name}::{device.DeviceCode}
                        </Option>
                      );
                    })}
                </Select>
                <Button
                  style={{ width: '5%' }}
                  type="primary"
                  onClick={() => {
                    this.setState({ treeVisible: true });
                  }}
                >
                  <UpSquareOutlined />
                </Button>
              </span>
            </Form.Item>
            <Form.Item
              label="Parameter Code"
              name="ParameterCode"
              rules={[{ required: false }]}
              style={{
                width: '100%',
                flex: '100%'
              }}
            >
              <Select
                placeholder="Please select Fault Code"
                style={{ width: '80%' }}
                mode={'multiple'}
                disabled={formObject && formObject.Id ? true : false}
              >
                {FaultCodesList &&
                  Array.isArray(FaultCodesList) &&
                  FaultCodesList.map((item, index) => {
                    return (
                      <Option
                        key={index}
                        value={item.Code !== 'All' ? `${item.DeviceCode}$$$${item.Code}` : 'All'}
                      >
                        {item.Code !== 'All' ? `${item.Description}@${item.DeviceName}` : 'All'}
                        {/*                      
                      value={`${item.DeviceCode}$$$${item.Code}`}>
                        {item.Description}@{item.DeviceName} */}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item
              label="Fault Interval"
              name="Interval"
              rules={[{ required: true }]}
              style={{
                width: '100%',
                flex: '100%'
              }}
            >
              {/* <Select style={{ width: "70%" }}>
                                {IntervalData && Array.isArray(IntervalData) && IntervalData.map((item, index) => {
                                    return <Option key={index} value={item.value}>{item.key}</Option>;
                                })}
                            </Select> */}
              <TimePicker
                format={'mm:ss'}
                style={{ width: '80%' }}
                // disabledTime={(e) => this.getDisableHours(e)}
                onChange={(value) => this.fieldOnChange(value, 'Interval')}
              />
            </Form.Item>
            <Form.Item
              label="Status"
              name="IntervalStatus"
              style={{
                width: '100%',
                flex: '100%'
              }}
              rules={[{ required: true }]}
            >
              <Select placeholder="Please select Status" style={{ width: '80%' }}>
                <Option key={'Enabled'} value={true}>
                  {'Enabled'}
                </Option>
                ;
                <Option key={'Disabled'} value={false}>
                  {'Disabled'}
                </Option>
                ;
              </Select>
            </Form.Item>
            <Form.Item
              style={{
                width: '100%',
                flex: '100%'
              }}
            ></Form.Item>
          </div>
          <StyledModal
            open={this.state.treeVisible}
            width={800}
            closable
            title={'Select Device'}
            okText={'Add'}
            onOk={this.onModalsOk}
            onCancel={this.onModalCancel}
          >
            <HierarchyModal
              selectedDevice={selectedDevice ? selectedDevice : []}
              treeData={this.state.hierarchy}
              Key="Trends"
              handleDropdownChange={this.hierarchyDropdownChange}
            />
          </StyledModal>
        </StyledForm>
      </StyledComponent>
    );
  }
}
export default SRHaltTime;
